import type { PersonalRunningNowFilterableField } from '@kirin/api-client/contracts/account-shadow-ai-running-now';
import { PERSONAL_RUNNING_NOW_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/account-shadow-ai-running-now';
import { TABLE_IDS } from '@/components/DataTable/tableIds';

export const PERSONAL_RUNNING_NOW_FILTER_URL_KEYS = {
  [PERSONAL_RUNNING_NOW_FILTERABLE_FIELDS.NAME]: 'n',
  [PERSONAL_RUNNING_NOW_FILTERABLE_FIELDS.CATEGORY]: 'cat',
  [PERSONAL_RUNNING_NOW_FILTERABLE_FIELDS.PID]: 'pid',
  [PERSONAL_RUNNING_NOW_FILTERABLE_FIELDS.PORT]: 'prt',
  [PERSONAL_RUNNING_NOW_FILTERABLE_FIELDS.STARTED_AT]: 'sa',
} as const satisfies Partial<Record<PersonalRunningNowFilterableField, string>>;

export const PERSONAL_RUNNING_NOW_TABLE_CONFIG = {
  tableId: TABLE_IDS.PERSONAL.SHADOW_AI.RUNNING,
} as const;
